/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/react';
import { tokens } from '@domain-group/fe-brary';

export const inputLabelOverride = css`
  padding-right: ${tokens.spacing.m};
`;
